import React from 'react';
import { useTranslation } from 'react-i18next';
import CardCmp from 'src/components/CardCmp';

const TermsAndConditions: React.FC = () => {
    const { t } = useTranslation();

    return (
        <CardCmp
            headerTitle={t('QuotingHub.TermsAndConditions.Title')}
            headerParentClassName="!rounded-t-lg !px-0 !mx-3"
            isCardContentWithoutSpacing={true}
            childrenClassName="widget-card-content-wrap"
        >
            <div className="px-3 py-3 space-y-3">
                <div className="flex flex-col">
                    <span className="text-[12px] leading-[18px] font-semibold  text-textSecondary">Appointments:</span>
                    <span className="text-[12px] leading-[18px] font-normal text-grayLight600">MAY BE SUBJECT TO A SURCHARGE</span>
                </div>
                <div className="flex flex-col">
                    <span className="text-[12px] leading-[18px] font-semibold  text-textSecondary">Loss/Damage Claims: </span>
                    <span className="text-[12px] leading-[18px] font-normal text-grayLight600">The maximum liability is $2.00 CAD per pound.</span>
                </div>
                <div className="flex flex-col">
                    <span className="text-[12px] leading-[18px] font-semibold  text-textSecondary">Currency:</span>
                    <span className="text-[12px] leading-[18px] font-normal text-grayLight600">
                        Rate is in the currency stipulated above, if no currency is mentioned, the funds are in Canadian Dollars
                    </span>
                </div>
                <div className="flex flex-col">
                    <span className="text-[12px] leading-[18px] font-semibold  text-textSecondary">Discrepancies:</span>
                    <span className="text-[12px] leading-[18px] font-normal text-grayLight600">Rate is subject to adjustment should the weight, size or quantities vary from initial assumptions.</span>
                </div>
                <div className="flex flex-col">
                    <span className="text-[12px] leading-[18px] font-semibold  text-textSecondary">Waiting Time:</span>
                    <span className="text-[12px] leading-[18px] font-normal text-grayLight600">{`2hrs free for loading/unloading FTL - 1hr free LTL > 4 skids - 30min < 4 skids- excess subject surcharge`}</span>
                </div>
                <div className="flex flex-col">
                    <span className="text-[12px] leading-[18px] font-semibold  text-textSecondary">Cancellations:</span>
                    <span className="text-[12px] leading-[18px] font-normal text-grayLight600">Any cancellations within 24hrs of pickup date could potentially be subject to cancellation fee</span>
                </div>
                <div className="flex flex-col">
                    <span className="text-[12px] leading-[18px] font-semibold  text-textSecondary">LTL:</span>
                    <span className="text-[12px] leading-[18px] font-normal text-grayLight600">Estimated delivery dates for LTL shipments are based on transit time and are subject to change</span>
                </div>
            </div>
        </CardCmp>
    );
};

export default TermsAndConditions;
